<template>
  <div class="campainRange">
    <div class="MeasurementBus">
      <div class="MeasurementBus__header">
        <div class="MeasurementBus__header__left">
          <div class="MeasurementBus__header__left__search">
            <i class="adx-ic_search"></i>
            <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
          </div>
        </div>
        <!-- <div class="MeasurementBus__header__right">
          <p>Sort by :</p>
          <div>
            <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
          </div>
        </div> -->
      </div>
    </div>
    <adx-table text="Tooltip button" 
      :loading.sync= "isLoading"
      :items.sync="data"  
      :isEmpty.sync="isEmpty"  
      @selectedAction="selectedAction">
    </adx-table>
    <div class="range" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Campaigns</div>
    <adx-pagination 
      v-if="!isLoading && !isEmpty"
      :max-page="maxPage"
      :selected-page="selectedPage"
      @change-page="selectPage"
    />
  </div>
</template>

<script>
  import Loading from '@/components/Loading/Primary'
  import Pagination from '@/components/Pagination'
  import DropdownSort from '@/components/Form/SelectDropdown'
  import table from '@/components/Table'
  import {helpers} from '@/lib/validation/'
  import api from '@/api'
  import {apiV2} from '@/api/urls'

  export default {
  name: 'adx-measurement-bus',
  components: {
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-dropdown-sort': DropdownSort,
    'adx-table': table, 
  },
  props: {

  },
  data() {
    return {
      result: [],
      retryCount: 0,
      isLoading: true,
      searchBoxValue:'',
      selectedPage: 1,
      currentPage: 1,
      next: 0,
      count: 0,
      page: 1,
      maxPage: 1,
      // selectedSortValue: 'created_date',
      // sort: [
      //   {
      //     'id': 0,
      //     'label': 'Created Date',
      //     'value': 'created_date'
      //   },
      //   {
      //     'id': 1,
      //     'label': 'Last Updated',
      //     'value': 'last_updated'
      //   },
      //   {
      //     'id': 2,
      //     'label': 'Price High to Low',
      //     'value': '-price'
      //   },
      //   {
      //     'id': 3,
      //     'label': 'Price Low to High',
      //     'value': 'price'
      //   },
      // ],
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "PERIOD",
            type: "period"
          },
          {
            title: "UNRESOLVED ISSUE",
            type: "text"
          },
          {
            title: "STATUS",
            type: "text"
          },
          {
            title: "",
            type: "icon"
          }
        ],
        body : []
      },
    }
  },
  computed: {
    isEmpty: function(){
      return !(this.data.body && this.data.body.length)
    },
    getDataRange: function(){
      return (this.count%15===0 || this.selectedPage===1) && this.count>15?this.selectedPage*15:(this.selectedPage*15-15)+(this.count%15)
    },
    getFilterParams: function () {
      return {
        search: this.searchBoxValue || undefined
      }
    }
  },
  watch: {
    selectedSortValue: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedPage = 1;
        this.selectedSortValue = newValue;
        this.getData()
      }
    },
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.getData()
      })
    }, 300),
  },
  beforeCreate() {
    
  },
  created() {

  },
  beforeMount() {
    
  },
  mounted() {
    this.getData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async getData(){
      let params = {
        ...this.getFilterParams
      };
      const { data } = await api.get(apiV2.monitoringCampaignDashboard, { needToken: true, params});
      this.count = data.count;
      this.result = data.results;
      this.mappingData()
    },
    async mappingData(){
      let body = [];
      let result = this.result;
      await result.map(res => {
        let issue = this.displayTotalItem(res.total_unresolved_issue);
        let valuesData = [
          { value: res.id},
          { value: res.title},
          { start: res.start, end:res.end},
          { value: issue},
          { value: "Launched"},
          { icon: "icon-eye", text: "View Detail"}
        ];
        body.push({
          id: res.id,
          values:valuesData
        });
      });
      this.data.body = body;
      this.count = result.length;
      this.isLoading = false
    },
    // filterdata(data){
    //   let campaign = data
    //   if (this.selectedSortValue == 'created_date') {
    //     campaign.sort(function(a,b){
    //       return new Date(b.start) - new Date(a.start);
    //     });
    //   }
    //   this.result = campaign
    //   this.mapData()
    // },
    // loadData() {
    //   let file = `/static/data/monitoring.json`;
    //   (async () => {
    //     let request = await fetch(new Request(file));
    //     let data = await request.json();
    //     let campaign = data.campaign;

    //     if(this.searchBoxValue !== '' && this.searchBoxValue.length >= 3){
    //       this.result = campaign.filter(m => {
    //         let title = m.title.toLowerCase();
    //         let channel = m.channel.toLowerCase();
    //         let search = this.searchBoxValue.toLowerCase();
    //         return title.indexOf(search) > -1 || channel.indexOf(search) > -1
    //       })
    //     } else {
    //       this.result = campaign
    //     }
    //     this.mapData()
    //   })();
    // },
    async mapData(){
      let body = [];
      let index = 1;
      let result = this.result;
      await result.forEach(res => {
        let issue = this.displayTotalItem(res.issue);
        let valuesData = [
          { value: index},
          { value: res.title},
          { value: res.channel},
          { start: res.start, end:res.end},
          { value: issue},
          { value: res.status},
          { icon: "icon-eye", text: "View Detail"}
        ];
        body.push({
          id: res.id,
          values:valuesData
        });
        index += 1
      });
      this.data.body = body;
      this.count = result.length;
      this.isLoading = false
    },
    displayTotalItem(item) {
      let issue = `-`;
      if (item === 1)
        issue = `${item} Issue`;
      else if (item > 1)
        issue = `${item} Issues`;
      return issue
    },
    selectedAction(id, type, item){
      let campaign = item.values[1].value;
      if(type === 'icon-eye'){
        this.$router.push({name: 'monitoringdetail', params: { id: item.id, campaign: campaign }})
      }else{
        this.$router.push({name: 'home'})
      }
    },
    async selectPage(item) {
      this.selectedPage = item;
      this.getData()
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
</style>